var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1 1V22H89","stroke":"white","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M67 43L90 22L67 0.999999","stroke":"white","strokeWidth":"2","key":1})]);
}

ArrowRight.defaultProps = {"width":"92","height":"44","viewBox":"0 0 92 44","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
